import { initializeApp } from "firebase/app";
import { getAuth, GoogleAuthProvider, connectAuthEmulator } from "firebase/auth";
import { getFirestore, connectFirestoreEmulator } from "firebase/firestore";

// Firebase configuration
const firebaseConfig = {
  apiKey: "AIzaSyAastCJ-3Kvrdu1E29lxYW2wEIy3o38zMM",
  authDomain: "prihoriva.firebaseapp.com",
  projectId: "prihoriva",
  storageBucket: "prihoriva.firebasestorage.app",
  messagingSenderId: "718074905179",
  appId: "1:718074905179:web:540f5527439808ad11757e",
  measurementId: "G-XGP77226VJ",
};

const app = initializeApp(firebaseConfig);
export const auth = getAuth(app);
// Localize Firebase's verification / password-reset emails AND their hosted
// action pages (the "e-mail ověřen" landing) to the deployed language. Without
// this Firebase falls back to English — confusing for non-English players.
// REACT_APP_LANGUAGE is baked per build (build:cs → 'cs', build:sk → 'sk', …).
auth.languageCode = process.env.REACT_APP_LANGUAGE || 'cs';
export const googleProvider = new GoogleAuthProvider();
export const db = getFirestore(app);

// Connect to Firebase Emulators only when REACT_APP_USE_EMULATOR=true
if (process.env.REACT_APP_USE_EMULATOR === 'true') {
  // Odkud se stránka načetla, tam běží i emulátory.
  //
  // Natvrdo „127.0.0.1" znamenalo VLASTNÍ počítač toho, kdo se dívá — takže
  // jakmile se někdo připojil přes lokální IP z jiného stroje, mířilo přihlášení
  // na jeho vlastní prázdný port a tiše selhalo. Nahlášeno 23. 9. 2026.
  //
  // Na localhostu z toho vyjde přesně to, co tu stálo předtím.
  const host = (typeof window !== 'undefined' && window.location.hostname) || '127.0.0.1';
  console.log(`🔧 Connecting to Firebase Emulators (${host})...`);
  try {
    connectAuthEmulator(auth, `http://${host}:9099`, { disableWarnings: true });
    connectFirestoreEmulator(db, host, 8081);
    console.log('✅ Connected to Firebase Emulators');
  } catch (e) {
    console.warn('⚠️  Could not connect to emulators:', e.message);
  }
} else {
  console.log(`🔥 Firebase initialized (${process.env.NODE_ENV} mode)`);
}
